import { HttpClient } from '@angular/common/http';
import { HttpClientService } from './http-client.service';
import { API_CONSTANT } from './api.constant';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
var ApiService = (function () {
    function ApiService(localHttp, http, translate) {
        this.localHttp = localHttp;
        this.http = http;
        this.translate = translate;
    }
    ApiService.prototype.getErrorMessage = function (error, delimiter) {
        if (error != null && error.error != null && error.error.message != null && error.error.message.length > 0) {
            return delimiter ? error.error.message.join(delimiter) : error.error.message.join('.');
        }
        else if (error != null && error.error != null && error.error.non_field_errors != null && error.error.non_field_errors.length > 0) {
            return error.error.non_field_errors.join(',');
        }
        else {
            return this.translate.instant('ERROR.TRY-AGAIN');
        }
    };
    ApiService.prototype.getErrorMessageDepartment = function (error, delimiter) {
        if (error != null && error.error != null && error.error.code != null && error.error.code.length > 0) {
            return delimiter ? error.error.code.join(delimiter) : error.error.code.join('.');
        }
        else if (error != null && error.error != null && error.error.name_en != null && error.error.name_en.length > 0) {
            return delimiter ? error.error.name_en.join(delimiter) : error.error.name_en.join('.');
        }
        else if (error != null && error.error != null && error.error.name_th != null && error.error.name_th.length > 0) {
            return delimiter ? error.error.name_th.join(delimiter) : error.error.name_th.join('.');
        }
        else if (error != null && error.error != null && error.error.abbreviation != null && error.error.abbreviation.length > 0) {
            return delimiter ? error.error.abbreviation.join(delimiter) : error.error.abbreviation.join('.');
        }
        else if (error != null && error.error != null && error.error.non_field_errors != null && error.error.non_field_errors.length > 0) {
            return error.error.non_field_errors.join(',');
        }
        else {
            return this.translate.instant('ERROR.TRY-AGAIN');
        }
    };
    ApiService.prototype.createDownloadFile = function (blob, filename) {
        // for IE10+
        if (typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        }
        else {
            var element = document.createElement('a');
            document.body.appendChild(element);
            var url = window.URL.createObjectURL(blob);
            element.setAttribute('href', url);
            element.setAttribute('download', filename);
            element.style.display = 'none';
            element.click();
            document.body.removeChild(element);
        }
    };
    ApiService.prototype.parseErrorBlob = function (err) {
        var reader = new FileReader();
        var obs = Observable.create(function (observer) {
            reader.onloadend = function (e) {
                try {
                    observer.error({ 'error': JSON.parse(reader.result) });
                }
                catch (e) {
                    observer.error({ 'error': null });
                }
                observer.complete();
            };
        });
        reader.readAsText(err.error);
        return obs;
    };
    ApiService.prototype.updatePassword = function (newPassword) {
        return this.http.patch(API_CONSTANT.set_password, newPassword);
    };
    ApiService.prototype.confirmPassword = function (password) {
        return this.http.post(API_CONSTANT.confirm_password, password);
    };
    ApiService.prototype.uploadCSV = function (document) {
        return this.http.post(API_CONSTANT.upload_csv, document);
    };
    ApiService.prototype.signSignature = function (document) {
        return this.http.postBlob(API_CONSTANT.sign_docs, document).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getBackgroundJobStatus = function (id) {
        return this.http.get(API_CONSTANT.background_jobs + id + '/');
    };
    ApiService.prototype.getTaxDataResult = function (data, params) {
        var url = API_CONSTANT.tax_data_upload_result;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.post(url, data);
    };
    ApiService.prototype.postSummary = function (data) {
        return this.http.post(API_CONSTANT.summary_csv, data);
    };
    ApiService.prototype.getSalesTaxReport = function (data) {
        return this.http.postBlob(API_CONSTANT.sales_tax_report, data).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getZip3MB = function (data) {
        return this.http.postBlob(API_CONSTANT.zip_file_three_megabyte, data).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getZip = function (data) {
        return this.http.getBlob(API_CONSTANT.zip_file, data).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getFileFullPath = function (full_path) {
        return this.http.getBlob(full_path).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.postSearch = function (data, params) {
        var url = API_CONSTANT.search_files;
        if (params != null)
            url += '?' + params;
        return this.http.post(url, data);
    };
    ApiService.prototype.postSearch1 = function (data, params) {
        return this.postSearch(data, params);
    };
    ApiService.prototype.sign_counter = function (data, params) {
        return this.http.post(API_CONSTANT.sign_counter + '?' + params, data);
    };
    ApiService.prototype.getUsers = function (params) {
        return this.http.get(API_CONSTANT.users, params);
    };
    ApiService.prototype.createUser = function (data) {
        return this.http.post(API_CONSTANT.users, data);
    };
    ApiService.prototype.updateUser = function (data) {
        return this.http.patch(API_CONSTANT.users + data.id + '/', data);
    };
    ApiService.prototype.deleteUser = function (data) {
        return this.http.delete(API_CONSTANT.users + data.id + '/');
    };
    ApiService.prototype.getRoles = function (params) {
        return this.http.get(API_CONSTANT.groups, params);
    };
    ApiService.prototype.getCompanyGroups = function (params) {
        return this.http.get(API_CONSTANT.company_groups, params);
    };
    ApiService.prototype.getMe = function (params) {
        return this.http.get(API_CONSTANT.me, params);
    };
    ApiService.prototype.getDashboardMonthlyData = function (data) {
        return this.http.get(API_CONSTANT.dashboard_monthly, data);
    };
    ApiService.prototype.getDashboardSignCounterMinute = function (data) {
        return this.http.get(API_CONSTANT.dashboard_sign_counter_minute, data);
    };
    ApiService.prototype.getCompany = function () {
        return this.http.get(API_CONSTANT.corporates);
    };
    ApiService.prototype.getBranch = function () {
        return this.http.get(API_CONSTANT.branches);
    };
    ApiService.prototype.getDropdownBranch = function () {
        return this.http.get(API_CONSTANT.branches + 'dropdown/');
    };
    ApiService.prototype.postSaleTax = function (data, params) {
        var url = API_CONSTANT.sales_tax_view;
        if (params != null)
            url += '?' + params;
        return this.http.post(url, data);
    };
    ApiService.prototype.postBulkSaleTax = function (data, params) {
        var url = API_CONSTANT.bulk_sales_tax_view;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.post(url, data);
    };
    ApiService.prototype.getErrors = function (params) {
        return this.http.get(API_CONSTANT.get_errors, params);
    };
    ApiService.prototype.postSaleZipTax = function (data, params) {
        var url = API_CONSTANT.sales_zip_tax;
        if (params != null)
            url += '?' + params;
        return this.http.post(url, data);
    };
    ApiService.prototype.postSubmitToRd = function (data, params) {
        var url = API_CONSTANT.submit_to_rd;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.post(url, data);
    };
    ApiService.prototype.getMissingDoc = function (params) {
        return this.http.getBlob(API_CONSTANT.export_missing_excel, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getBulkMissingDoc = function (params) {
        return this.http.getBlob(API_CONSTANT.export_bulk_missing_excel, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.approveSale = function (params) {
        return this.http.post(API_CONSTANT.approve_sale_tax, params);
    };
    ApiService.prototype.approveUploadSale = function (params) {
        return this.http.post(API_CONSTANT.approve_upload_sale, params);
    };
    ApiService.prototype.updateSettings = function (params) {
        return this.http.post(API_CONSTANT.update_settings, params);
    };
    ApiService.prototype.getSettings = function () {
        return this.http.get(API_CONSTANT.get_settings);
    };
    ApiService.prototype.getAllDocs = function (params) {
        return this.http.getBlob(API_CONSTANT.export_all_docs, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getBulkAllDocs = function (params) {
        return this.http.getBlob(API_CONSTANT.export_bulk_all_docs, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.downloadFileFromMediaPath = function (url) {
        return this.http.getBlob(API_CONSTANT.MEDIA_PATH_URL + url).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getAllZipFile = function (params) {
        return this.http.postBlob(API_CONSTANT.export_zip_file, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getAllExcelFile = function (params) {
        return this.http.postBlob(API_CONSTANT.export_excel_submit_to_rd, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getExcelReport = function (params) {
        return this.http.getBlob(API_CONSTANT.export_monthly_excel_report, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.submitCheckedToRd = function (params) {
        return this.http.post(API_CONSTANT.submit_checked_to_rd, params);
    };
    ApiService.prototype.getEmailDashboard = function (params) {
        return this.http.get(API_CONSTANT.email_report, params);
    };
    ApiService.prototype.getBuyer = function (params) {
        return this.http.get(API_CONSTANT.buyer, params);
    };
    ApiService.prototype.getNewBuyer = function () {
        return this.http.get(API_CONSTANT.buyer);
    };
    ApiService.prototype.getExternalBuyerData = function (params) {
        return this.http.get(API_CONSTANT.buyer + "external/", params);
    };
    ApiService.prototype.getBuyerBranch = function (params) {
        return this.http.get(API_CONSTANT.buyer_branch, params);
    };
    ApiService.prototype.getSellerBranch = function (params) {
        return this.http.get(API_CONSTANT.seller_branch, params);
    };
    ApiService.prototype.postB2PDocumentSummary = function (data, params) {
        var url = API_CONSTANT.b2p_document_summary;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.post(url, data);
    };
    ApiService.prototype.postB2PDocumentSummaryDetail = function (data, params) {
        var url = API_CONSTANT.b2p_document_summary_detail;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.post(url, data);
    };
    ApiService.prototype.downloadB2PDocumentSummaryDetailExcel = function (data, params) {
        var url = API_CONSTANT.b2p_document_summary_detail_excel;
        if (params != null) {
            url += '?' + params;
        }
        return this.http.postBlob(url, data).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getBillingExcelReport = function (params) {
        return this.http.getBlob(API_CONSTANT.export_sign_counter_excel_monthly_report, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getActionsLogExcelReport = function (params) {
        return this.http.getBlob(API_CONSTANT.export_actions_log_excel_report, params).pipe(catchError(this.parseErrorBlob));
    };
    ApiService.prototype.getCountry = function (params) {
        return this.http.get(API_CONSTANT.country, params);
    };
    ApiService.prototype.getAllBuyerEmailsReport = function () {
        return this.http.get(API_CONSTANT.all_buyer_emails_report);
    };
    ApiService.prototype.getAllImportMethods = function () {
        return this.http.get(API_CONSTANT.all_import_methods);
    };
    ApiService.prototype.createBuyerBranch = function (data) {
        return this.http.post(API_CONSTANT.buyer_branch, data);
    };
    ApiService.prototype.updateBuyerBranch = function (id, data) {
        return this.http.patch(API_CONSTANT.buyer_branch + id + '/', data);
    };
    ApiService.prototype.createSellerBranch = function (data) {
        return this.http.post(API_CONSTANT.seller_branch, data);
    };
    ApiService.prototype.updateSellerBranch = function (id, data) {
        return this.http.patch(API_CONSTANT.seller_branch + id + '/', data);
    };
    ApiService.prototype.createETaxInvoice = function (data) {
        return this.http.post(API_CONSTANT.create_etax_invoice, data);
    };
    ApiService.prototype.sendEmailETaxInvoice = function (data) {
        return this.http.post(API_CONSTANT.send_email_etax_invoice, data);
    };
    ApiService.prototype.checkMatchedInvoiceNumber = function (params) {
        return this.http.get(API_CONSTANT.matched_invoice_number, params);
    };
    // RD Send Report
    ApiService.prototype.getRDSendReport = function (params) {
        return this.http.get(API_CONSTANT.rd_send_results, params);
    };
    ApiService.prototype.resendToRD = function (taxDataId) {
        return this.http.post(API_CONSTANT.rd_send_results + taxDataId + '/resend/', {});
    };
    ApiService.prototype.resendAllPendingEbxml = function (data) {
        return this.http.post(API_CONSTANT.resend_all_pending_ebxml, data);
    };
    ApiService.prototype.getLatestManualResendTime = function (data) {
        return this.http.get(API_CONSTANT.get_latest_manual_resend_time, data);
    };
    // Logout
    ApiService.prototype.logout = function () {
        return this.http.post(API_CONSTANT.logout, null);
    };
    ApiService.prototype.sniff = function (data) {
        return this.http.post(API_CONSTANT.history_log, data);
    };
    ApiService.prototype.getActions = function () {
        return this.http.get(API_CONSTANT.history_log_type);
    };
    ApiService.prototype.getSniffs = function (params) {
        return this.http.get(API_CONSTANT.history_log, params);
    };
    ApiService.prototype.getProducts = function (params) {
        return this.http.get(API_CONSTANT.product, params);
    };
    ApiService.prototype.createProduct = function (data) {
        return this.http.post(API_CONSTANT.product, data);
    };
    ApiService.prototype.updateProduct = function (id, data) {
        return this.http.patch(API_CONSTANT.product + id + '/', data);
    };
    ApiService.prototype.deleteProduct = function (id) {
        return this.http.delete(API_CONSTANT.product + id);
    };
    ApiService.prototype.getDocumentRequestInfo = function (id) {
        return this.http.get("" + API_CONSTANT.document_request + id + "/document-issue/");
    };
    ApiService.prototype.getDocumentRequest = function (params) {
        return this.http.get(API_CONSTANT.document_request, params);
    };
    ApiService.prototype.getDocumentResponseDetail = function (id) {
        return this.http.get("" + API_CONSTANT.document_request + id + "/");
    };
    ApiService.prototype.cancelDocumentRequest = function (id) {
        return this.http.post("" + API_CONSTANT.document_request + id + "/cancel/", {});
    };
    ApiService.prototype.restoreDocumentRequest = function (id) {
        return this.http.post("" + API_CONSTANT.document_request + id + "/restore/", {});
    };
    ApiService.prototype.deleteDocumentRequest = function (id) {
        return this.http.delete("" + API_CONSTANT.document_request + id + "/");
    };
    ApiService.prototype.getDocumentRequestDropdown = function (params) {
        return this.http.get(API_CONSTANT.document_request_dropdown, params);
    };
    ApiService.prototype.createDocumentRequest = function (params) {
        return this.http.post(API_CONSTANT.document_request, params);
    };
    ApiService.prototype.getDepartments = function (params) {
        return this.http.get(API_CONSTANT.department, params);
    };
    ApiService.prototype.createDepartment = function (data) {
        return this.http.post(API_CONSTANT.department, data);
    };
    ApiService.prototype.updateDepartment = function (id, data) {
        return this.http.patch(API_CONSTANT.department + id + '/', data);
    };
    ApiService.prototype.deleteDepartment = function (id) {
        return this.http.delete(API_CONSTANT.department + id);
    };
    ApiService.prototype.getAbbData = function (params) {
        return this.http.get(API_CONSTANT.abb_data, params);
    };
    ApiService.prototype.getAbbDetail = function (id) {
        return this.http.get(API_CONSTANT.abb_data + id + '/');
    };
    ApiService.prototype.getAbbDataDropdown = function (params) {
        return this.http.get(API_CONSTANT.abb_data + 'dropdown/', params);
    };
    ApiService.prototype.getABBOutletDropdown = function () {
        return this.http.get(API_CONSTANT.abb_data + 'dropdown-outlet/');
    };
    ApiService.prototype.getInvoiceNumber = function (params) {
        return this.http.get(API_CONSTANT.get_invoice_number, params);
    };
    return ApiService;
}());
export { ApiService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/api.service.ts.pre-build-optimizer.js